import { jsx as _jsx } from "react/jsx-runtime";
import { AllInclusive as IconAllInclusive } from "@mui/icons-material";
import { UiIconDiscord, UiIconElama, UiIconFacebook, UiIconFacebookDangerous, UiIconGoogle, UiIconInstagram, UiIconInstagramDangerous, UiIconLinkedin, UiIconMax, UiIconOk, UiIconPinterest, UiIconTelegram, UiIconTenchat, UiIconTikTok, UiIconTwitter, UiIconViber, UiIconVk, UiIconYandex, UiIconYoutube, } from "../icons";
export const UiIconMedium = ({ className, isDisplayingIconDangerous, medium, size = "medium", }) => {
    if (medium === "all") {
        return _jsx(IconAllInclusive, { className: className, fontSize: size });
    }
    if (medium === "discord") {
        return _jsx(UiIconDiscord, { className: className, fontSize: size });
    }
    if (medium === "facebook") {
        return isDisplayingIconDangerous ? (_jsx(UiIconFacebookDangerous, { className: className, fontSize: size })) : (_jsx(UiIconFacebook, { className: className, fontSize: size }));
    }
    if (medium === "instagram" || medium === "instagram_business") {
        return isDisplayingIconDangerous ? (_jsx(UiIconInstagramDangerous, { className: className, fontSize: size })) : (_jsx(UiIconInstagram, { className: className, fontSize: size }));
    }
    if (medium === "linkedin") {
        return _jsx(UiIconLinkedin, { className: className, fontSize: size });
    }
    if (medium === "ok") {
        return _jsx(UiIconOk, { className: className, fontSize: size });
    }
    if (medium === "pinterest") {
        return _jsx(UiIconPinterest, { className: className, fontSize: size });
    }
    if (medium === "telegram") {
        return _jsx(UiIconTelegram, { className: className, fontSize: size });
    }
    if (medium === "telegram_mtproto") {
        return _jsx(UiIconTelegram, { className: className, fontSize: size });
    }
    if (medium === "tiktok") {
        return _jsx(UiIconTikTok, { className: className, fontSize: size });
    }
    if (medium === "twitter") {
        return _jsx(UiIconTwitter, { className: className, fontSize: size });
    }
    if (medium === "viber") {
        return _jsx(UiIconViber, { className: className, fontSize: size });
    }
    if (medium === "vk") {
        return _jsx(UiIconVk, { className: className, fontSize: size });
    }
    if (medium === "youtube") {
        return _jsx(UiIconYoutube, { className: className, fontSize: size });
    }
    if (medium === "elama") {
        return _jsx(UiIconElama, { className: className, fontSize: size });
    }
    if (medium === "tenchat") {
        return _jsx(UiIconTenchat, { className: className, fontSize: size });
    }
    if (medium === "yandex") {
        return _jsx(UiIconYandex, { className: className, fontSize: size });
    }
    if (medium === "google") {
        return _jsx(UiIconGoogle, { className: className, fontSize: size });
    }
    if (medium === "max") {
        return _jsx(UiIconMax, { className: className, fontSize: size });
    }
    return null;
};
//# sourceMappingURL=ui_icon_medium.js.map